import Jost400Book from './assets/fonts/Jost-400-Book.ttf';
import Jost600Semi from './assets/fonts/Jost-600-Semi.ttf';

const FONT_FACE = `
  @font-face {
  font-family: 'Jost';
  font-display: fallback;
  font-weight: 400;
  src: local('Jost'), 
       url(${Jost400Book}) format('truetype');
  font-style: normal;
}

@font-face {
  font-family: 'Jost';
  font-display: fallback;
  font-weight: 600;
  src: local('Jost'),
       url(${Jost600Semi}) format('truetype');
  font-style: normal;
}
`;

export { FONT_FACE };
